import { ErrorCodeMap } from './error-code-map.types';

/**
 * offer-service `ExceptionErrorCodes` (range 10001-10264).
 * Generated from the backend registry; see error-codes.md for the full inventory.
 *
 * Excluded: 9 codes defined but never thrown by the backend, so they can never
 * reach the client (10092, 10093, 10115, 10141, 10146, 10149, 10152, 10158, 10203).
 *
 * `surface: false` = internal / not user-actionable (id, slug, filter, order-position
 * and locale validation, hash/revision mismatches). Review and flip as needed.
 */
export const OFFER_ERROR_CODES: ErrorCodeMap = {
  10001: { key: 'offerInvalidAccessCode', surface: true },
  10002: { key: 'offerInvalidId', surface: false },
  10003: { key: 'offerInvalidOnlinePaymentPercentage', surface: true },
  10004: { key: 'offerInvalidOrderPosition', surface: false },
  10005: { key: 'offerInvalidQuantity', surface: true },
  10006: { key: 'offerInvalidSoldItems', surface: true },
  10007: { key: 'offerInvalidStatus', surface: true },
  10008: { key: 'offerCantBeDeleted', surface: true },
  10009: { key: 'offerCantBeModified', surface: true },
  10010: { key: 'offerNotFound', surface: true },
  10011: { key: 'admissionGeneralAdmissionIdInvalid', surface: true },
  10012: { key: 'admissionTableIdInvalid', surface: true },
  10013: { key: 'italyRegulationInvalidAbbonamentoId', surface: true },
  10014: { key: 'italyRegulationInvalidAbbonamentoType', surface: true },
  10015: { key: 'italyRegulationInvalidDirittoPrevendita', surface: true },
  10016: { key: 'bottleServiceAlreadyExists', surface: true },
  10017: { key: 'bottleServiceNotFound', surface: true },
  10018: { key: 'bottleServiceInvalidGuestCapacity', surface: true },
  10019: { key: 'guestListAlreadyExists', surface: true },
  10020: { key: 'guestListNotFound', surface: true },
  10021: { key: 'guestListInvalidOnlinePaymentPercentage', surface: true },
  10022: { key: 'passNotFound', surface: true },
  10023: { key: 'ticketAlreadyExists', surface: true },
  10024: { key: 'ticketNotFound', surface: true },
  10025: { key: 'offerImageInvalidOrderPosition', surface: false },
  10026: { key: 'offerImageInvalidImageUrl', surface: true },
  10027: { key: 'offerTranslationInvalidDescription', surface: true },
  10028: { key: 'offerTranslationInvalidLocale', surface: false },
  10029: { key: 'offerTranslationInvalidName', surface: true },
  10030: { key: 'offerCommissionInvalidTransactionFee', surface: true },
  10031: { key: 'offerCommissionInvalidTransactionFeeStrategy', surface: true },
  10032: { key: 'offerCommissionInvalidXceedCommission', surface: true },
  10033: { key: 'offerCommissionInvalidXceedCommissionStrategy', surface: true },
  10034: { key: 'offerItemsPerTransactionInvalid', surface: true },
  10035: { key: 'offerItemsPerTransactionInvalidMaxItems', surface: true },
  10036: { key: 'offerItemsPerTransactionInvalidMinItems', surface: true },
  10037: { key: 'offerPriceInvalidCurrency', surface: true },
  10038: { key: 'offerPriceInvalidAmount', surface: true },
  10039: { key: 'offerSalesTimeInvalid', surface: true },
  10040: { key: 'bookingFormFieldMandatory', surface: true },
  10041: { key: 'bookingFormFieldNotFound', surface: true },
  10042: { key: 'bookingFormFieldInvalidDataType', surface: true },
  10043: { key: 'bookingFormFieldInvalidId', surface: false },
  10044: { key: 'bookingFormFieldInvalidName', surface: true },
  10045: { key: 'bookingFormFieldInvalidSlug', surface: false },
  10046: { key: 'channelAlreadyRelated', surface: true },
  10047: { key: 'channelNotFound', surface: true },
  10048: { key: 'channelInvalidId', surface: false },
  10049: { key: 'companyInvalidId', surface: false },
  10050: { key: 'eventNotFound', surface: true },
  10051: { key: 'eventInvalidId', surface: false },
  10052: { key: 'formFieldPresetInvalidDataType', surface: true },
  10053: { key: 'formFieldPresetInvalidId', surface: false },
  10054: { key: 'formFieldPresetInvalidName', surface: true },
  10055: { key: 'formFieldPresetInvalidSlug', surface: false },
  10056: { key: 'offerChannelInvalidMaxQuantity', surface: true },
  10057: { key: 'ticketHolderFormFieldNotFound', surface: true },
  10058: { key: 'ticketHolderFormFieldInvalidDataType', surface: true },
  10059: { key: 'ticketHolderFormFieldInvalidId', surface: false },
  10060: { key: 'ticketHolderFormFieldInvalidName', surface: true },
  10061: { key: 'ticketHolderFormFieldInvalidSlug', surface: false },
  10062: { key: 'offerPresetInvalidFilter', surface: false },
  10063: { key: 'offerPresetInvalidId', surface: false },
  10064: { key: 'admissionPresetTicketHolderFormFieldInvalidId', surface: false },
  10065: { key: 'admissionPresetTicketHolderFormFieldNotFound', surface: true },
  10066: { key: 'bottleServicePresetAlreadyExists', surface: true },
  10067: { key: 'bottleServicePresetNotFound', surface: true },
  10068: { key: 'guestListPresetAlreadyExists', surface: true },
  10069: { key: 'guestListPresetNotFound', surface: true },
  10070: { key: 'ticketPresetAlreadyExists', surface: true },
  10071: { key: 'ticketPresetNotFound', surface: true },
  10072: { key: 'offerPresetBookingFormFieldInvalidId', surface: false },
  10073: { key: 'offerPresetBookingFormFieldNotFound', surface: true },
  10074: { key: 'offerMaxItemsPerTransactionGreaterThanQuantity', surface: true },
  10075: { key: 'admissionPresetNotFound', surface: true },
  10076: { key: 'offerImageInvalidImageId', surface: true },
  10077: { key: 'offerPresetNotFound', surface: true },
  10078: { key: 'admissionNotFound', surface: true },
  10079: { key: 'admissionCheckinTimeInvalid', surface: true },
  10080: { key: 'offerInvalidChannelDefaultMaxQuantity', surface: true },
  10081: { key: 'admissionInvalidFilter', surface: false },
  10082: { key: 'floorplanAlreadyExists', surface: true },
  10083: { key: 'floorplanEventNotMatchAdmissionEvent', surface: true },
  10084: { key: 'floorplanNotFound', surface: true },
  10085: { key: 'invalidFloorplanId', surface: true },
  10086: { key: 'invalidFloorplanImageUrl', surface: true },
  10087: { key: 'invalidFloorplanName', surface: true },
  10088: { key: 'floorplanPresetAlreadyExists', surface: true },
  10089: { key: 'floorplanPresetNotFound', surface: true },
  10090: { key: 'invalidFloorplanPresetFilter', surface: true },
  10091: { key: 'invalidFloorplanPresetId', surface: true },
  10094: { key: 'eventAlreadyHasAFloorplan', surface: true },
  10095: { key: 'channelInvalidSlug', surface: false },
  10096: { key: 'italyRegulationOfferCantBeUnhidden', surface: true },
  10097: { key: 'invalidAdmissionDrinksIncluded', surface: true },
  10098: { key: 'ticketHolderFormFieldMandatory', surface: true },
  10099: { key: 'offerCannotBeSiaeApproved', surface: true },
  10100: { key: 'eventAlreadyExists', surface: true },
  10101: { key: 'addOnPresetNotFound', surface: true },
  10102: { key: 'invalidAddOnPresetId', surface: true },
  10103: { key: 'invalidAddOnType', surface: true },
  10104: { key: 'invalidAddOnPrice', surface: true },
  10105: { key: 'invalidAddOnCurrency', surface: true },
  10106: { key: 'invalidAddOnQuantity', surface: true },
  10107: { key: 'invalidAddOnTranslationLocale', surface: true },
  10108: { key: 'invalidAddOnTranslationName', surface: true },
  10109: { key: 'invalidAddOnTranslationDescription', surface: true },
  10110: { key: 'invalidAddOnId', surface: true },
  10111: { key: 'invalidAddOnSoldItems', surface: true },
  10112: { key: 'addOnNotFound', surface: true },
  10113: { key: 'invalidAddOnTransactionFee', surface: true },
  10114: { key: 'invalidAddOnAbsorbedFee', surface: true },
  10116: { key: 'invalidOfferAddOnOrderPosition', surface: true },
  10117: { key: 'offerCommissionInvalidTransactionFeeAbsorbed', surface: true },
  10118: { key: 'addOnEventNotMatchAdmissionEvent', surface: true },
  10119: { key: 'offerAddOnNotFound', surface: true },
  10120: { key: 'invalidAddOnItemsIncluded', surface: true },
  10121: { key: 'offerInvalidColor', surface: true },
  10122: { key: 'addOnCantBeModified', surface: true },
  10123: { key: 'offerOnlinePriceInvalidAmount', surface: true },
  10124: { key: 'offerOfflinePriceInvalidAmount', surface: true },
  10125: { key: 'eventOfferMismatch', surface: true },
  10126: { key: 'eventOfferOrderPositionInvalid', surface: true },
  10127: { key: 'invalidAdmissionCircularReference', surface: true },
  10128: { key: 'invalidSalesTimeForOfferReleases', surface: true },
  10129: { key: 'floorPlanPresetAdmissionPresetNotFound', surface: true },
  10130: { key: 'unableToDeleteAdmissionPresetAssignedToExistingFloorplanPresets', surface: true },
  10131: { key: 'passValidityTimeInvalid', surface: true },
  10132: { key: 'passDayValidityInvalid', surface: true },
  10133: { key: 'seasonPassNotFound', surface: true },
  10134: { key: 'staffPassNotFound', surface: true },
  10135: { key: 'eventPassAlreadyExists', surface: true },
  10136: { key: 'eventPassNotFound', surface: true },
  10137: { key: 'offerInvalidFilter', surface: false },
  10138: { key: 'offerInvalidSalesStatus', surface: true },
  10139: { key: 'floorplanAreaInvalidId', surface: false },
  10140: { key: 'floorplanAreaInvalidName', surface: true },
  10142: { key: 'floorplanAreaInvalidImageUrl', surface: true },
  10143: { key: 'floorplanAreaInvalidColor', surface: true },
  10144: { key: 'floorplanAreaAlreadyExists', surface: true },
  10145: { key: 'floorplanAreaNotFound', surface: true },
  10147: { key: 'floorplanAreaPresetInvalidId', surface: false },
  10148: { key: 'floorplanAreaPresetInvalidName', surface: true },
  10150: { key: 'floorplanAreaPresetInvalidImageUrl', surface: true },
  10151: { key: 'floorplanAreaPresetInvalidColor', surface: true },
  10153: { key: 'floorplanAreaPresetNotFound', surface: true },
  10154: { key: 'floorplanAreaPresetAlreadyExists', surface: true },
  10155: { key: 'invalidOfferHasMandatoryAddOns', surface: true },
  10156: { key: 'invalidOfferAddOnChoiceMode', surface: true },
  10157: { key: 'invalidFloorplanMenuUrl', surface: true },
  10159: { key: 'invalidEventEndingTime', surface: true },
  10160: { key: 'invalidEventDates', surface: true },
  10161: { key: 'invitationNotFound', surface: true },
  10162: { key: 'invitationAlreadyExists', surface: true },
  10163: { key: 'invitationListPresetAlreadyExists', surface: true },
  10164: { key: 'channelInvalidName', surface: true },
  10165: { key: 'bookingFormFieldMinValueInvalid', surface: true },
  10166: { key: 'bookingFormFieldMaxValueInvalid', surface: true },
  10167: { key: 'bookingFormFieldNumericRangeInvalid', surface: true },
  10168: { key: 'bookingFormFieldInvalid', surface: true },
  10169: { key: 'noChannelsAssigned', surface: true },
  10170: { key: 'cannotEnable18App', surface: true },
  10171: { key: 'invalidBottleServiceVatRate', surface: true },
  10172: { key: 'invalidPassVatRate', surface: true },
  10173: { key: 'invalidTicketVatRate', surface: true },
  10174: { key: 'vatRateNotFound', surface: true },
  10175: { key: 'invalidOfferVatRate', surface: true },
  10176: { key: 'invalidOfferPresetVatRate', surface: true },
  10177: { key: 'companyNotFound', surface: true },
  10178: { key: 'companyAlreadyExists', surface: true },
  10179: { key: 'passWithoutCompany', surface: true },
  10180: { key: 'teamInvalidId', surface: false },
  10181: { key: 'teamInvalidName', surface: true },
  10182: { key: 'eventTeamInvalidMaxQuantity', surface: true },
  10183: { key: 'eventChannelInvalidMaxQuantity', surface: true },
  10184: { key: 'teamNotFound', surface: true },
  10185: { key: 'offerTeamInvalidMaxQuantity', surface: true },
  10186: { key: 'eventTeamNotFound', surface: true },
  10187: { key: 'invalidId', surface: false },
  10188: { key: 'venueInvalidId', surface: false },
  10189: { key: 'userInvalidId', surface: false },
  10190: { key: 'seatingItemNotFound', surface: true },
  10191: { key: 'seatingGroupNotFound', surface: true },
  10192: { key: 'seatingItemPresetNotFound', surface: true },
  10193: { key: 'seatingGroupPresetNotFound', surface: true },
  10194: { key: 'floorplanViewportSnapshotNotFound', surface: true },
  10195: { key: 'floorplanPresetViewportSnapshotNotFound', surface: true },
  10196: { key: 'cannotDetachStandaloneFloorplan', surface: true },
  10197: { key: 'cannotAttachStandaloneFloorplanToPreset', surface: true },
  10198: { key: 'invalidFloorplanPresetAppliedRevision', surface: true },
  10199: { key: 'seatingItemDontBelongToFloorplan', surface: false },
  10200: { key: 'revisionDoesntMatchWithFloorplan', surface: true },
  10201: { key: 'impactPlanIsNotAcknowledged', surface: true },
  10202: { key: 'seatingGroupDontBelongToFloorplan', surface: false },
  10204: { key: 'offerGroupTranslationInvalidLocale', surface: false },
  10205: { key: 'offerGroupTranslationInvalidName', surface: true },
  10206: { key: 'invalidOfferGroupId', surface: true },
  10207: { key: 'invalidOfferGroupItemPosition', surface: true },
  10208: { key: 'invalidSectionId', surface: true },
  10209: { key: 'invalidSectionPosition', surface: true },
  10210: { key: 'sectionTranslationInvalidLocale', surface: false },
  10211: { key: 'sectionTranslationInvalidName', surface: true },
  10212: { key: 'sectionTranslationInvalidDescription', surface: true },
  10213: { key: 'sectionItemInvalidPosition', surface: false },
  10214: { key: 'offerGroupNotFound', surface: true },
  10215: { key: 'sectionNotFound', surface: true },
  10216: { key: 'sectionOfferTypeInvalid', surface: true },
  10217: { key: 'offerGroupCannotBeDeleted', surface: true },
  10218: { key: 'sectionAlreadyExists', surface: true },
  10219: { key: 'offerAlreadyAssignedToAnotherGroup', surface: true },
  10220: { key: 'revisionDoesntMatchWithFloorplanPreset', surface: true },
  10221: { key: 'invalidSectionItemId', surface: true },
  10222: { key: 'invalidOfferGroupItemId', surface: true },
  10223: { key: 'cannotGroupLockedSeatingItems', surface: true },
  10224: { key: 'floorplanEventPast', surface: true },
  10225: { key: 'editorLocked', surface: true },
  10226: { key: 'editorLockNotOwned', surface: true },
  10227: { key: 'editorLockNotFound', surface: true },
  10228: { key: 'channelAlreadyExists', surface: true },
  10229: { key: 'offerGroupDeleteHashMismatch', surface: false },
  10230: { key: 'invalidOfferTicketsLeftThreshold', surface: true },
  10231: { key: 'invalidTicketThreshold', surface: true },
  10232: { key: 'invalidGuestListThreshold', surface: true },
  10233: { key: 'invalidBottleServiceThreshold', surface: true },
  10234: { key: 'invalidPassThreshold', surface: true },
  10235: { key: 'companyTicketsLeftThresholdNotFound', surface: true },
  10236: { key: 'invalidPortugueseTaxId', surface: true },
  10237: { key: 'companyOfferMismatch', surface: true },
  10238: { key: 'invalidPassCircularReference', surface: true },
  10239: { key: 'invalidAddOnVatRate', surface: true },
  10240: { key: 'invalidDrinksAddOnVatRate', surface: true },
  10241: { key: 'invalidInsuranceAddOnVatRate', surface: true },
  10242: { key: 'invalidTransportAddOnVatRate', surface: true },
  10243: { key: 'invalidAccommodationAddOnVatRate', surface: true },
  10244: { key: 'invalidDonationAddOnVatRate', surface: true },
  10245: { key: 'invalidAddOnCheckoutMode', surface: true },
  10246: { key: 'invalidAddOnMinQuantityPerTicket', surface: true },
  10247: { key: 'invalidAddOnMaxQuantityPerTicket', surface: true },
  10248: { key: 'invalidAddOnQuantityPerTicketRange', surface: true },
  10249: { key: 'insuranceAddOnCheckoutModeMustBeFixed', surface: true },
  10250: { key: 'invalidAddOnImageId', surface: true },
  10251: { key: 'invalidAddOnImageUrl', surface: true },
  10252: { key: 'invalidAddOnImageOrderPosition', surface: true },
  10253: { key: 'addOnMaxImagesReached', surface: true },
  10254: { key: 'invalidAddOnPresetImageId', surface: true },
  10255: { key: 'invalidAddOnPresetImageUrl', surface: true },
  10256: { key: 'invalidAddOnPresetImageOrderPosition', surface: true },
  10257: { key: 'addOnPresetMaxImagesReached', surface: true },
  10258: { key: 'bottleServiceInvalidExtraGuestMaxQuantity', surface: true },
  10259: { key: 'bottleServiceInvalidPricePerExtraGuest', surface: true },
  10260: { key: 'ticketHolderFormFieldMinValueInvalid', surface: true },
  10261: { key: 'ticketHolderFormFieldMaxValueInvalid', surface: true },
  10262: { key: 'ticketHolderFormFieldNumericRangeInvalid', surface: true },
  10263: { key: 'invalidOfferDistribution', surface: true },
  10264: { key: 'bottleServiceSiaeGuestLimitExceeded', surface: true },
};
